<template>
<div class="topic-list">
<div class="container-fluid">
  <div class="table-responsive margin-Top-6Perc overflowXHidden">
    <table class="table table-striped">
      <thead>
        <tr>
          <th class="text-align-center font-size-15px border-right">Topic Name</th>
          <th class="text-align-center font-size-15px border-right">Created TS</th>
          <th class="text-align-center font-size-15px border-right">Updated TS</th>
          <th class="text-align-center font-size-15px">Actions</th>
        </tr>
      </thead>
      <tbody>
        <tr v-for="mastertopicObj in getMasterTopicList" :key="mastertopicObj.CohortId" v-bind:mastertopicObj="mastertopicObj" > 
          <td class="border-right text-align-center col-lg-6">{{mastertopicObj.Title}}</td>
          <td class="border-right text-align-center col-lg-2">{{formatAndShowDate(mastertopicObj.CreatedTS)}}</td>
          <td class="border-right text-align-center col-lg-2">{{formatAndShowDate(mastertopicObj.UpdatedTS)}}</td>
          <td class="border-right text-align-center col-lg-2">
            <a class="cursor-pointer" @click="performClickOperation($event,'view', mastertopicObj)"> View  </a>|
            <a class="cursor-pointer" @click="performClickOperation($event,'update', mastertopicObj)"> Edit  </a>|
            <a class="cursor-pointer" @click="performClickOperation($event,'delete', mastertopicObj)"> Delete</a>
          </td>
        </tr>
      </tbody>
    </table>
    </div>
  </div>
  <confirmation-alert v-if="showConfirmationBox" v-bind:dataObj="null" v-bind:prefixString="prefixDeleteTopicString" v-bind:postfixString="postDeleteTopicString" @showConfirmationBox="updateShowConfirmationAlertFlag" @userConfirmation="userConfirmation"></confirmation-alert>
  <view-master-topic-overlay v-if="showViewMasterTopicOverlay" :selectedMasterTopicObj="getSelectedMasterTopicObj" @closeOverlay="CloseCurrentOpenTopicOverlay"></view-master-topic-overlay>
  <update-master-topic-overlay v-if="showUpdateMasterTopicOverlay" :selectedMasterTopicObj="getSelectedMasterTopicObj" @closeOverlay="CloseCurrentOpenTopicOverlay"></update-master-topic-overlay>
  <!-- Show Spinner -->
  <div class="animationload" v-show="showSpinner">
    <div class="osahanloading"></div>
  </div>
  <alert-box v-if="showAlertDialog" v-bind:errorMsg="errorMsg" @showAlertBox="updateShowAlertDialogFlag"></alert-box>
  <loader></loader>
</div>
</template>
<script>
import UpdateMasterTopicOverlay from '@/components/master_topic/UpdateMasterTopicOverlay'
import ViewMasterTopicOverlay from '@/components/master_topic/ViewMasterTopicOverlay'
import AlertBox from '@/components/AlertOverlay'
import { dmAdminUtils } from '@/utils/dmAdminUtils'
import { masterTopicService } from '@/server-util/master-topic-service'
import Loader from '@/components/dashboard/Loader'
import findIndex from 'lodash/findIndex'
import filter from 'lodash/filter'
import ConfirmationOverlay from '@/components/ConfirmationOverlay'
export default {
  props: ['masterTopicList'],
  data: function () {
    return {
      showViewMasterTopicOverlay: false,
      showUpdateMasterTopicOverlay: false,
      selectedMasterTopicObj: null,
      showSpinner: false,
      showAlertDialog: false,
      errorMsg: '',
      prefixDeleteTopicString: '',
      postDeleteTopicString: '',
      showConfirmationBox: false
    }
  },
  name: 'topic-list',
  methods: {
    userConfirmation (value) {
      this.showConfirmationBox = false
      if (value) {
        this.deleteSelectedTopic()
      }
    },
    updateShowConfirmationAlertFlag (value) {
      // AK: Used when user pressed close button of delete element overlay
      this.showConfirmationBox = value
    },
    CloseCurrentOpenTopicOverlay (value) {
      const closeOverlay = value.closeOverlay
      const updatedObj = value.updatedObj
      if (updatedObj !== null) {
        const currObjIndex = findIndex(this.getMasterTopicListFromState, (obj) => {
          return obj.MasterTopicId === updatedObj.MasterTopicId
        })
        if (currObjIndex !== -1) {
          this.getMasterTopicListFromState[currObjIndex] = updatedObj
        }
        this.$emit('updatedMasterTopicList', this.masterTopicList)
      }
      this.showViewMasterTopicOverlay = !closeOverlay
      this.showUpdateMasterTopicOverlay = !closeOverlay
      // AK: Enable Background Scrolling
      this.$store.state.isOverlayVisible = !closeOverlay
    },
    formatAndShowDate: function (date) {
      var dateToPass = date
      if (dateToPass.indexOf('Z') === -1) {
        dateToPass += 'Z'
      }
      return dmAdminUtils.covertUtcToEst(dateToPass)
    },
    performClickOperation: function (event, selectedOperation, selectedObj) {
      this.selectedMasterTopicObj = selectedObj
      // console.log(JSON.stringify(this.selectedMasterTopicObj))
      switch (selectedOperation) {
        case 'view':
          this.showViewMasterTopicOverlay = true
          // AK: Disable Background Scrolling
          this.$store.state.isOverlayVisible = true
          break
        case 'update':
          this.showUpdateMasterTopicOverlay = true
          // AK: Disable Background Scrolling
          this.$store.state.isOverlayVisible = true
          break
        case 'delete':
          this.showConfirmationBox = true
          this.prefixDeleteTopicString = 'Are you sure you want delete '
          this.postDeleteTopicString = '\'' + this.selectedMasterTopicObj.Title + '\' master topic?'
          break
      }
    },
    deleteSelectedTopic: function () {
      var storeObj = this.$store
      var _this = this
      if (
        this.selectedMasterTopicObj.MasterTopicId !== undefined &&
        this.selectedMasterTopicObj.MasterTopicId !== null &&
        this.selectedMasterTopicObj.MasterTopicId !== 'null'
      ) {
        // _this.showSpinner = true
        _this.$store.state.isLoading = true
        masterTopicService
          .deleteMasterTopic(
            storeObj.state.access_token,
            this.selectedMasterTopicObj.MasterTopicId
          )
          .then(
            responseObj => {
              if (responseObj.status >= 200 && responseObj.status < 300) {
                // AK: Remove selected topic object
                this.removeSelectedObjFromList()
                _this.$store.state.isLoading = false
              } else {
                _this.showAlertDialog = true
                _this.errorMsg =
                  'Oops! Something went wrong. Please try again.'
                // _this.showSpinner = false
                _this.$store.state.isLoading = false
              }
            },
            errorObj => {
              // AK: Hide Spinner
              // this.showSpinner = false
              _this.$store.state.isLoading = false
              this.showAlertDialog = true
              this.errorMsg = errorObj.response.data.statusText
            }
          )
      } else {
        console.log(
          'MasterTopicId is NULL hence declined DELETE TOPIC OPERATION'
        )
      }
    },
    updateShowAlertDialogFlag (value) {
      this.showAlertDialog = value
    },
    removeSelectedObjFromList: function () {
      var listToReturn = filter(this.getMasterTopicListFromState, (obj) => {
        return this.selectedMasterTopicObj.MasterTopicId !== obj.MasterTopicId
      })
      this.$emit('updatedMasterTopicList', listToReturn)
    }
  },
  components: {
    'confirmation-alert': ConfirmationOverlay,
    'update-master-topic-overlay': UpdateMasterTopicOverlay,
    'view-master-topic-overlay': ViewMasterTopicOverlay,
    'alert-box': AlertBox,
    'loader': Loader
  },
  computed: {
    getMasterTopicList: {
      get: function () {
        return this.masterTopicList
      }
    },
    getSelectedMasterTopicObj: {
      get: function () {
        return this.selectedMasterTopicObj
      }
    },
    getMasterTopicListFromState: {
      get: function () {
        return this.$store.state.masterTopicList
      },
      set: function (newValue) {
        this.$store.state.masterTopicList = newValue
      }
    }
  }
}
</script>
<style scoped>
.animationload {
  height: 100%;
  left: 0;
  position: fixed;
  top: 0;
  width: 100%;
  z-index: 10000;
}
.osahanloading {
  animation: 1.5s linear 0s normal none infinite running osahanloading;
  background: #fed37f none repeat scroll 0 0;
  border-radius: 50px;
  height: 50px;
  left: 50%;
  margin-left: -25px;
  margin-top: -25px;
  position: absolute;
  top: 50%;
  width: 50px;
}
.osahanloading::after {
  animation: 1.5s linear 0s normal none infinite running osahanloading_after;
  border-color: #85d6de transparent;
  border-radius: 80px;
  border-style: solid;
  border-width: 10px;
  content: "";
  height: 80px;
  left: -15px;
  position: absolute;
  top: -15px;
  width: 80px;
}
@keyframes osahanloading {
  0% {
    transform: rotate(0deg);
  }
  50% {
    background: #85d6de none repeat scroll 0 0;
    transform: rotate(180deg);
  }
  100% {
    transform: rotate(360deg);
  }
}
.text-align-left {
  text-align: left;
}
.margin-Top-1Perc {
  margin-top: 1%;
}
.margin-Top-2Perc {
  margin-top: 2%;
}
.margin-Top-3Perc {
  margin-top: 3%;
}
.margin-Top-6Perc {
  margin-top: 6%;
}
.margin-left-1Perc {
  margin-left: 1%;
}
.margin-left-2Perc {
  margin-left: 2%;
}
.margin-right-2Perc {
  margin-right: 2%;
}
.overflow-x-hidden {
  overflow-x: hidden !important;
}
.topic-list {
  font-family: "Avenir", Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
  padding-left: inherit;
  padding-right: inherit;
}
.table-striped > tbody > tr:nth-child(2n + 1) > td,
.table-striped > tbody > tr:nth-child(2n + 1) > th {
  background-color: #ddd;
}
.border-right {
  border-right: 1px solid #aaa !important;
}
.text-align-center {
  text-align: center !important;
}
.font-size-15px {
  font-size: 15px !important;
}
a:link {
  color: #2c3e50;
}
a:visited {
  color: #2c3e50;
}
a:hover {
  color: #2c3e50;
}
a:active {
  color: #2c3e50;
}
.btn-text-color {
  color: #2c3e50;
}
.cursor-pointer {
  cursor: pointer;
}
.text-decoration-underline {
  text-decoration: underline;
}
.table>thead>tr>th {
    vertical-align: bottom;
    border-bottom: 0px solid #aaaaaa;
}
.text-align-center{
  text-align: center !important;
}

a:link{
  color: #2c3e50 !important;
  text-decoration: none !important;
} 
a:visited{
  color: #2c3e50 !important;
  text-decoration: none !important;
}
a:hover{
  color: #2c3e50 !important;
  text-decoration: none !important;
}
a:active{
  color: #2c3e50 !important;
  text-decoration: none !important;
}
a{
  color: #2c3e50 !important;
}
.overflowXHidden {
  overflow-x: hidden;
}
</style>


// WEBPACK FOOTER //
// src/components/master_topic/TopicList.vue